import { styled } from '@linaria/react';

// NOTE: This export is used by several files. That's why I moved it to a .helpers module.
export const BasicImage = styled.img`
  display: block;
  border-radius: 4px;
  width: 100%;
  /*
    This is needed for next/image, to avoid stretching it out.
    It works (in those situations) because the parent sets an explicit width + aspect-ratio, so the height is known.
  */
  height: 100%;
`;
